/**
 * Issues a file download using native browser streaming.
 *
 * @param src URL to download
 * @param filename of the downloaded file unless taken from the Content-Disposition header
 */
export const download = (src: string, filename = '') => {
  const a = global.document.createElement('a');
  a.style.setProperty('display', 'none');
  a.href = src;
  a.download = filename;

  window.document.body.appendChild(a);
  a.click();
  window.document.body.removeChild(a);
};
